import React from 'react';
import { Box } from '@mui/material';

export default function PaymentCenterCard() {
  return (
    <Box className="card" id="vendPaymentCard" style={{ minHeight: '300px' }}>
      <div className="card-head">
        <h3 className="card-title">Payment Center</h3>
      </div>
      <div className="tile-row">
        <div className="payable-tile" onClick={() => window.vendShowDetail?.('invoice-stage', 'payment-due')}>
          <p className="kpi-label">Total pending</p>
          <p className="kpi-value" style={{ fontSize: '19px' }}>₹3.36L</p>
          <div className="kpi-sub flat">3 invoices</div>
        </div>
        <div className="payable-tile" onClick={() => window.vendShowDetail?.('invoice', 'INV-4007')}>
          <p className="kpi-label">Upcoming payment</p>
          <p className="kpi-value" style={{ fontSize: '19px' }}>₹29,400</p>
          <div className="kpi-sub flat">25 Aug 2026</div>
        </div>
        <div className="payable-tile" onClick={() => window.vendShowDetail?.('invoice', 'INV-3021')}>
          <p className="kpi-label">Overdue</p>
          <p className="kpi-value" style={{ fontSize: '19px', color: 'var(--red)' }}>₹1,45,000</p>
          <div className="kpi-sub down">16 days overdue</div>
        </div>
      </div>
    </Box>
  );
}
